export enum TitleEnum {
    Dr = "dr",
    Mr = "mr",
    Mrs = "mrs",
    Ms = "ms",
    Professor = "professor",
    Miss = "miss"
}